export default __webpack_public_path__ + "edde44053da7d64b4f1fa82cfef8a55e.png";